import React, { useState } from 'react';
import { Dialog, DialogPanel,  Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { Bars3Icon, XMarkIcon, MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline';
import {
  AcademicCapIcon,
  CheckCircleIcon,
  HandRaisedIcon,
  RocketLaunchIcon,
  SparklesIcon,
  SunIcon,
  UserGroupIcon,
} from '@heroicons/react/20/solid';
import HeaderOne from "./components/NavBar";
import Footer from "./components/Footer";
import Scroll from './scrollToTop'
import headerImage from './images/mission-picture.jpg';
import mission1Image from './images/mission-iconi.png';
import mission2Image from './images/mission-icon2.png';
import mission3Image from './images/mission-icon3.png';
import mission4Image from './images/mission-icon4.png';

import alexImage from './images/deemer.jpg';
import jadeImage from './images/jade.jpg';
const faqs = [
  {
    question: "How can I contact customer support?",
    answer:
    'Contact us by emailing customerservices@enablesend.co.uk or visit the <a href="/contact" class="text-blue-500 underline">contact us</a> page.',
  },
  {
    question: "When will my query be responded to?",
    answer:
      "Queries will be answered within 5 working days.",
  },
  {
    question: "How is my data stored?",
    answer:
      "We adhere to strict GDPR regulations, all data is stored securely on encrypted servers and databases. All sensitive information, such as payment details, is encrypted using industry-standard protocols via third-party payment providers. For more information read our <a href='/privacy' class='text-blue-500 underline'>privacy policy</a>.",
  },
  {
    question: "Why is this a paid service?",
    answer:
      "Whilst we know funding in the SEND sector is limited, we are all about transparency and we feel our prices are fairly represented to cover the running and further development of enableSEND. Our ultimate aim is to make this a free resource to families by leading the discussion on empowering inclusivity across all provision and increasing focus on the SEND community. Our costs are 20p per day for families based on yearly subscription. If your local authority is signed up, you will get your subscription for free!",
  },
];


const values = [
  {
    name: 'Be world-class.',
    description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit aute id magna.',
    icon: RocketLaunchIcon,
  },
  {
    name: 'Take responsibility.',
    description: 'Anim aute id magna aliqua ad ad non deserunt sunt. Qui irure qui lorem cupidatat commodo.',
    icon: HandRaisedIcon,
  },
  {
    name: 'Be supportive.',
    description: 'Ac tincidunt sapien vehicula erat auctor pellentesque rhoncus voluptas blanditiis et.',
    icon: UserGroupIcon,
  },
  {
    name: 'Always learning.',
    description: 'Iure sed ab. Aperiam optio placeat dolor facere. Officiis pariatur eveniet atque et dolor.',
    icon: AcademicCapIcon,
  },
  {
    name: 'Share everything you know.',
    description: 'Laudantium tempora sint ut consectetur ratione. Ut illum ut rem numquam fuga delectus.',
    icon: SparklesIcon,
  },
  {
    name: 'Enjoy downtime.',
    description: 'Culpa dolorem voluptatem velit autem rerum qui et corrupti. Quibusdam quo placeat.',
    icon: SunIcon,
  },
];
const team = [
  {
    name: 'Alex',
    role: 'Co-Founder',
    imageUrl:alexImage,
    // location: 'Toronto, Canada',
  },
  {
    name: 'Jade',
    role: 'Co-Founder',
    imageUrl:jadeImage,
  },];
const benefits = [
  'Competitive salaries',
  'Flexible work hours',
  '30 days of paid vacation',
  'Annual team retreats',
  'Benefits for you and your family',
  'A great work environment',
];

export default function Example() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="bg-white">
      <Scroll/>
      {/* Header */}
      <HeaderOne/>

      <main className="relative isolate">
        {/* Background */}
        {/* <div
          aria-hidden="true"
          className="absolute inset-x-0 top-4 -z-10 flex transform-gpu justify-center overflow-hidden blur-3xl"
        >
          <div
            style={{
              clipPath:
                'polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%)',
            }}
            className="aspect-[1108/632] w-[69.25rem] flex-none bg-gradient-to-r from-[#80caff] to-[#4f46e5] opacity-25"
          />
        </div> */}

        {/* Header section */}
        <div className="px-6 pt-0 lg:px-8">
          <div className="mx-auto max-w-2xl pt-16 text-center sm:pt-28">
            <h1 className="text-4xl font-semibold tracking-tight text-black sm:text-6xl">Our vision is lasting change</h1>
            <p className="mt-8 text-pretty text-lg font-medium text-gray-700 sm:max-w-2xl sm:text-xl/8 lg:max-w-none">
              We're here to improve the future of SEND provision for good. Read below our four key mission objectives.
            </p>
          </div>
          
          {/* Add the image section */}
          <div className="mt-16 flex justify-center">
            <img
              src={headerImage}
              alt="Enable SEND Vision"
              className="rounded-2xl object-cover w-full max-w-5xl h-[400px] shadow-xl"
            />
          </div>
        </div>



        {/* Content section */}
      {/* Content section */}
<div className="mx-auto mt-20 max-w-7xl px-6 lg:px-8">
  <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
    
    {/* Add the main heading here */}
    <h2 className="text-2xl font-bold text-center text-gray-900 mb-8">Our Mission</h2>
    
    <div className="grid max-w-xl grid-cols-1 gap-8 text-base/7 text-gray-700 lg:max-w-none lg:grid-cols-2">
      
      <div>
        <div className="flex items-start gap-6 mb-8">
          <img 
            src={mission1Image} 
            alt="SEND Community Support"
            className="w-28 h-28 "
          />
          <p>
            Supporting the SEND community to achieve their full potential through equal and fair access to the services around them. We believe in providing opportunities for everyone, ensuring no one is left behind.
          </p>
        </div>
        
        <div className="flex items-start gap-6 mt-8">
          <img 
            src={mission2Image} 
            alt="Breaking Down Barriers"
            className="w-28 h-28 "
          />
          <p>
            We are dedicated to breaking down barriers and filling the gaps in services. Our mission is to push forward best practices in SEND services, making them accessible for all, regardless of background or needs.
          </p>
        </div>
      </div>
      
      <div>
        <div className="flex items-start gap-6">
          <img 
            src={mission3Image} 
            alt="Championing SEND"
            className="w-28 h-28 "
          />
          <p>
            We aim to bring disability into the mainstream, championing SEND and transforming the current landscape. By raising awareness and pushing for inclusive practices, we are striving for lasting change.
          </p>
        </div>
        
        <div className="flex items-start gap-6 mt-8">
          <img 
            src={mission4Image} 
            alt="Supporting Families"
            className="w-28 h-28 "
          />
          <p>
            EnableSEND creates a space for parents, carers, and professionals to access the information and support they need. Our platform fosters a greater understanding of disability needs, helping children and young people thrive in an accepting and inclusive environment.
          </p>
        </div>
      </div>
    
    </div>
  </div>
</div>


        {/* Image section */}
        {/* <div className="mt-32 sm:mt-40 xl:mx-auto xl:max-w-7xl xl:px-8">
          <img
            alt=""
            src="https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2894&q=80"
            className="aspect-[9/4] w-full object-cover xl:rounded-3xl"
          />
        </div> */}

        {/* Values section */}
        {/* <div className="mx-auto mt-32 max-w-7xl px-6 sm:mt-40 lg:px-8">
          <div className="mx-auto max-w-2xl lg:mx-0">
            <h2 className="text-pretty text-4xl font-semibold tracking-tight text-black sm:text-5xl">Our values</h2>
            <p className="mt-6 text-lg/8 text-gray-700">
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis suscipit eaque, iste
              dolor cupiditate blanditiis.
            </p>
          </div>
          <dl className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 text-base/7 text-gray-700 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3 lg:gap-x-16">
            {values.map((value) => (
              <div key={value.name} className="relative pl-9">
                <dt className="inline font-semibold text-black">
                  <value.icon aria-hidden="true" className="absolute left-1 top-1 h-5 w-5 text-gray-700" />
                  {value.name}
                </dt>{' '}
                <dd className="inline">{value.description}</dd>
              </div>
            ))}
          </dl>
        </div> */}


{/* faq section */}
<div className="bg-white">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8 lg:py-40">
        <div className="mx-auto max-w-4xl divide-y divide-gray-900/10">
          <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            Frequently asked questions
          </h2>
          <dl className="mt-10 space-y-6 divide-y divide-gray-900/10">
            {faqs.map((faq) => (
              <Disclosure key={faq.question} as="div" className="pt-6">
                <dt>
                  <DisclosureButton className="group flex w-full items-start justify-between text-left text-gray-900">
                    <span className="text-base/7 font-semibold">{faq.question}</span>
                    <span className="ml-6 flex h-7 items-center">
                      <PlusSmallIcon aria-hidden="true" className="size-6 group-data-[open]:hidden" />
                      <MinusSmallIcon aria-hidden="true" className="size-6 [.group:not([data-open])_&]:hidden" />
                    </span>
                  </DisclosureButton>
                </dt>
                <DisclosurePanel as="dd" className="mt-2 pr-12">
                <p
      className="mt-2 text-gray-700"
      dangerouslySetInnerHTML={{ __html: faq.answer }}
    ></p>                </DisclosurePanel>
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>

        {/* Team section */}
        <div className="mx-auto  max-w-7xl px-6 sm:mt-40 lg:px-8">
  <div className="mx-auto max-w-2xl lg:mx-0 text-center"> {/* Added text-center for centering */}
    <h2 className="text-pretty text-4xl font-semibold tracking-tight text-black sm:text-5xl">Our team</h2>
    <p className="mt-6 text-lg/8 text-gray-700">
      Hi, we are Alex and Jade
    </p>
  </div>
  <ul
    role="list"
    className="mx-auto mt-20 grid max-w-lg grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-2" 
  >
    {team.map((person) => (
      <li key={person.name} className="text-center">
        <img alt={person.name} src={person.imageUrl} className="aspect-[2/3] w-full rounded-2xl object-cover" />
        <h3 className="mt-6 text-lg/8 font-semibold tracking-tight text-gray-900">{person.name}</h3>
        <p className="text-base/7 text-gray-700">{person.role}</p>
        <p className="text-sm/6 text-gray-600">{person.location}</p>
      </li>
    ))}
  </ul>
</div>

<div className="mx-auto mt-32 max-w-7xl px-6 sm:mt-40 lg:px-8 pb-40"> {/* Added pb-20 */}
  <div className="mx-auto max-w-2xl lg:mx-0 text-center">
    <p className="mt-6 text-lg/8 text-gray-700">
      We are on a mission to change access to services for children, young people, and their families who are part of the SEND community!
    </p>
  </div>
  
  <div className="mt-16 space-y-8">

  <p className="mt-8 text-lg text-gray-700 leading-relaxed">
  We both have personal experience with SEND and neurodiversity within our families, meaning we have a vested interest in improving access to services, information, and bringing SEND to the mainstream!    </p>
    <p className="text-lg text-gray-700 leading-relaxed">
    Between us, we have over 30 years of experience working within disability services for both children and adults within London local authorities. We have seen firsthand the difficulties and barriers that children and young people face in finding play and social opportunities; and even when something is found, access can still be an issue.    </p>
    <p className="text-lg text-gray-700 leading-relaxed">
    We have seen parents and carers becoming increasingly frustrated and feeling unsupported by their own communities. Providers too are unclear on how to navigate the SEND system and know how and what support to ask for.  As professionals in this area, we have shared these feelings and know how difficult it is.    </p>
    
    <div className="mt-10">
      <p className="mt-4 text-lg text-gray-700 leading-relaxed">
      Jade has a special interest in inclusion, spending the last 10 years championing fair and equal access for SEND within mainstream play services. Her fundamental areas of work have been supporting mainstream services by removing barriers and enabling access through support such as staff training, consultation, and engagement. She has many years of experience on the practice side; working throughout many areas of social care assessing need.
      </p>
    </div>
    
    <div className="mt-10">
      <p className="mt-4 text-lg text-gray-700 leading-relaxed">
      Alex's vast experience lies in the areas of SEND consultation, business planning, development of service provision, and project management. He has set up services from the ground up, implementing best SEND practices and working closely with commissioning of operational services. He has led Ofsted inspections from a local authority service level and understands the need for a balance between budgets and a high quality SEND offer. 
       </p>
    </div>
    
   
  </div>
</div>

<div className="bg-blue-100">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:flex lg:items-center lg:justify-between lg:px-8">
        <h2 className="max-w-2xl text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
          Ready to join our community? <br />
          Start your journey today.
        </h2>
        <div className="mt-10 flex items-center gap-x-6 lg:mt-0 lg:flex-shrink-0">
          <a
            href="/signup"
            className="rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Sign Up
          </a>
          <a href="/" className="text-sm/6 font-semibold text-gray-900">
            Learn more <span aria-hidden="true">→</span>
          </a>
        </div>
      </div>
    </div>

       
      </main>

      {/* Footer */}
      <Footer/>
    </div>
  );
}
